import { ConfirmDialog } from '@agilelab/plugin-wb-platform';
import { useFeatureRequestMutations } from '../../hooks/useFeatureRequestMutations';

interface FeatureRequestDeleteDialogProps {
  open: boolean;
  featureRequestId: string;
  summary: string;
  onClose: () => void;
  onDeleted: () => void;
}

export const FeatureRequestDeleteDialog = ({
  open,
  featureRequestId,
  summary,
  onClose,
  onDeleted,
}: FeatureRequestDeleteDialogProps) => {
  const { deleteRequest } = useFeatureRequestMutations();

  const handleConfirm = () => {
    deleteRequest.mutate(featureRequestId, {
      onSuccess: () => onDeleted(),
    });
  };

  return (
    <ConfirmDialog
      open={open}
      title="Delete Feature Request"
      description={`Are you sure you want to delete "${summary}"? This action cannot be undone.`}
      confirmButtonText="Delete"
      confirmColor="secondary"
      inProgress={deleteRequest.isLoading}
      onConfirm={handleConfirm}
      onClose={onClose}
    />
  );
};
